import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import { RPResponseT, RPGetParamsT, RPItemResponseT } from '@/core/types/rp.types'

export class RPRepository {
    generateRP(): Promise<AxiosResponse<{ message: string }>> {
        return http.post('/cabinet/api/payment-lists', {})
    }

    getList(params: RPGetParamsT): Promise<AxiosResponse<RPResponseT>> {
        return http.get('/cabinet/api/payment-lists', { params })
    }

    getRP(id: number): Promise<AxiosResponse<RPItemResponseT>> {
        return http.get(`/cabinet/api/payment-lists/${id}`, { params: { id } })
    }

    exportRPKListExcel(id: number): Promise<any> {
        return http.get(`/cabinet/api/payment-lists/${id}/download-couriers`, {
            responseType: 'blob',
        })
    }

    exportRPPListExcel(id: number): Promise<any> {
        return http.get(`/cabinet/api/payment-lists/${id}/download-suppliers`, {
            responseType: 'blob',
        })
    }

    getExpressList(page: number): Promise<AxiosResponse<any>> {
        const params = {
            page,
        }

        return http.get('/delivery/api/payment-lists', { params })
    }

    generateExpressRP(): Promise<AxiosResponse<void>> {
        return http.post('/delivery/api/payment-lists', {})
    }

    exportExpressRPKListExcel(id: number): Promise<any> {
        return http.get(`/delivery/api/payment-lists/${id}/download-couriers`, {
            responseType: 'blob',
        })
    }
}
